import { Base } from '@studiometa/js-toolkit';

/**
 * Slider component
 */
export default class GalleryNav extends Base {
  currentPosition = 0;

  /**
   * Breakpoints
   */
  breakpoints = ['xxs', 'xs', 's'];

  /**
   * Component configuration
   */
  static config = {
    name: 'GalleryNav',
    refs: ['dots[]'],
  };

  /**
   *
   */
  mounted() {
    this.sliderItems = this.$parent.slides;
    this.offsetHeader =
      document.querySelector('.main-header').offsetHeight +
      document.querySelector('.top-header').offsetHeight;

    if (!this.isMobile) {
      const observer = new IntersectionObserver(this.checkIntersection.bind(this), {
        threshold: 0.5,
      });

      this.sliderItems.forEach((target) => {
        observer.observe(target);
      });
    }
  }

  /**
   * Check gallery intersection
   * @param  {object} entries
   * @returns {void}
   */
  checkIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const position = this.sliderItems.indexOf(entry.target);

        this.$refs.dots[this.currentPosition].classList.add('opacity-30');
        this.currentPosition = position;
        this.$refs.dots[this.currentPosition].classList.remove('opacity-30');
      }
    });
  }

  /**
   * Handle dot click event
   * @param {object} params Event parameters
   * @param {number} params.index Dot index
   */
  onDotsClick({ index }) {
    const scrollTarget = this.$parent.slides[index];

    window.scrollTo({
      top: scrollTarget.offsetTop + (index === 0 ? 0 : this.offsetHeader),
      behavior: 'smooth',
    });
  }

  /**
   * Check if current breakpoint is mobile
   * @returns {boolean}
   */
  get isMobile() {
    return this.breakpoints.includes(this.$services.get('resized').breakpoint);
  }
}
